import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { RutasService } from '../../services/rutas.service';
import { AlertasModales } from '../../helpers/alertasModales';
import { EmpleadosServicio } from '../../services/empleado.service';
import { UploadFilesService } from '../../services/upload-files.service';
import { ClientesService } from '../../services/Clientes.service';
import { PadronService } from '../../services/padron.service';
import { Helper } from '../../helpers/helper';

@Component({
  selector: 'app-editar-solicitud',
  templateUrl: './editar-solicitud.component.html',
  styleUrls: ['./editar-solicitud.component.css']
})
export class EditarSolicitudComponent implements OnInit {
  tiempo = ['dia(s)', 'semana(s)', 'mes(es)', 'año(s)'];

  form: FormGroup;
  loading: boolean;
  negocioRequired = false;
  rutas: any = [ ];
  cedula_encontrada = false;
  private config: Observable<any>;
  mask: any;
  imgCedula: File;
  empleados = [];
  hasFoto = false;
  private foto;
  fotoCedula = 'assets/img/cedula.png';

  constructor(
    private route: Router,
    private rutasService: RutasService,
    public alerts: AlertasModales,
    private empleadoService: EmpleadosServicio,
    private uploadFileService: UploadFilesService,
    private clienteService: ClientesService,
    private padron: PadronService,
    private params: ActivatedRoute,
    private helper: Helper
  ) {
    this.mask = { mask: '000-0000000-0', len : 13, type: 'num'};
    this.cargarRutas();
    this.initConfig();
    this.setFormulario();

  }

  ngOnInit() {
    this.initForm();
    this.initEmpleados();

    const datosNegocio = this.form.get('datosNegocio');
    datosNegocio.get('negocio_nombre').valueChanges
    .subscribe(res => {
      if (res) {
        for (const key of Object.keys(datosNegocio.value)) {
          // tslint:disable-next-line:max-line-length
          if (key === 'negocio_salario' || key === 'negocio_tiempo' || key === 'negocio_actividad' || key === 'negocio_telefono' || key === 'negocio_direccion') {
            datosNegocio.get(key).setValidators(Validators.required);
            datosNegocio.get(key).updateValueAndValidity();
            this.negocioRequired = true;
          }
        }
      } else {
        this.negocioRequired = false;
        for (const key of Object.keys(datosNegocio.value)) {
          datosNegocio.get(key).clearValidators();
        }
      }
    });
  }

  scrollTop() {
    const options: any = {
      behavior: 'smooth',
      top: 0,
      left: 0,
    };
    window.scrollTo(options);
  }

  // Cargar todas las rutas
  cargarRutas(): void {
    this.rutasService.cargarTodasLasRutas()
    .subscribe(result => { this.rutas = result.rutas; });
  }

  private initForm(): void {
    // Inicializar el formulario de cliente
    this.form = new FormGroup({
      'ID_SOLICITUD': new FormControl('', Validators.required),
      'identificacion': new FormControl('1', Validators.required),
      'ID_EMPLEADO': new FormControl(''),
      'foto_perfil': new FormControl({value: '', disable: true}),
      'fecha_nacimiento': new FormControl('', Validators.required),
      'estado_civil': new FormControl('', Validators.required),
      'cedula': new FormControl('', Validators.required),
      'nombre': new FormControl('', Validators.required),
      'apellido': new FormControl('', Validators.required),
      'monto': new FormControl('', Validators.required),
      'sexo': new FormControl('1', Validators.required),
      'telefono': new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(20)]),
      'ID_RUTA': new FormControl('', Validators.required),
      'direccion': new FormControl('', Validators.required),
      'apodo': new FormControl(''),
      'dependientes': new FormControl(''),
      'finalidad': new FormControl(''),
      'vivienda_propia': new FormControl(''),
      'vivienda_alquiler': new FormControl(''),
      'vivienda_tiempo': new FormControl(''),
      'datosNegocio': new FormGroup({
        'negocio_propio': new FormControl(''),
        'negocio_alquiler': new FormControl(''),
        'negocio_rnc': new FormControl(''),
        'negocio_nombre': new FormControl(''),
        'negocio_local': new FormControl(''),
        'negocio_telefono': new FormControl(''),
        'negocio_direccion': new FormControl(''),
        'negocio_actividad': new FormControl(''),
        'negocio_salario': new FormControl(''),
        'negocio_tiempo': new FormControl(''),
        'negocio_frecuencia_salario': new FormControl('')
      })
    });

    if (!this.form.get('ID_RUTA').value) {
      this.form.get('ID_EMPLEADO').disable();
    }

    this.config.subscribe(res => {
      if (res.solicitud.foto_cedula_requerido) {
        this.form.get('foto_perfil').setValidators(Validators.required);
        this.form.get('foto_perfil').updateValueAndValidity();
      }
    });
  }

  private initEmpleados(): void {
    this.form.get('ID_RUTA').valueChanges.subscribe(res => {
      if (res) {
        this.empleadoService.empleadosPorRutasAsignadas(res)
        .subscribe(result => {
          this.empleados = result;
          this.form.get('ID_EMPLEADO').enable();
        });
      } else {
        this.form.get('ID_EMPLEADO').setValue('');
        this.form.get('ID_EMPLEADO').disable();
        this.empleados = [];
      }
    });

  }

  identificacionChange() {
    this.mask =  (this.form.get('identificacion').value === '1' ?
    {mask: '000-0000000-0', len: 13} : '');
    this.form.get('cedula').markAsUntouched();
    this.form.get('cedula').setValue('');
    this.form.get('cedula').updateValueAndValidity();
  }

  cedulaChange(event) {
    this.form.get('cedula').setValue(event.target.value);
    this.form.get('cedula').clearValidators();
    if (this.form.get('identificacion').value === '1') {

      this.form.get('cedula').setValidators([Validators.required, Validators.minLength(13)]);
      if ( this.form.get('cedula').value.length - 2 === 11) {
      this.searchCedula();
      } else {
        this.form.get('nombre').setValue('');
        this.form.get('apellido').setValue('');
        this.cedula_encontrada = false;
      }
    } else {
      this.form.get('cedula').setValidators(Validators.required);
    }
    this.form.get('cedula').markAsTouched();
    this.form.get('cedula').updateValueAndValidity();
  }

  private initConfig(): void {
    this.config = this.clienteService.obtenerConfiguracion();
  }

  searchCedula() {
    if ( this.form.get('identificacion').value === '1') {
      this.padron.getCedula(this.form.get('cedula').value)
      .subscribe( (res: any) => {
        if (res) {
          this.form.get('nombre').setValue(res.solicitud.data.nombre);
          this.form.get('apellido').setValue(res.solicitud.data.apellidos);
          this.cedula_encontrada = true;
        }
      }, () => {
        this.form.get('nombre').setValue('');
        this.form.get('apellido').setValue('');
        this.cedula_encontrada = false;
      });
    }
  }

  loadFile(file: any) {
    // Validar que exista una img
    if (file.files.length > 0 && file.files[0].type.startsWith('image')) {
      this.imgCedula = file.files[0];

      // Cargar un preview de la img seleccionada
      const reader = new FileReader();
      reader.onload = (e: any) => {

        $('#preview').attr('src', e.target.result);
      };
      // tslint:disable-next-line:no-unused-expression
      reader.readAsDataURL(this.imgCedula);
      this.form.get('foto_perfil').setValue(this.imgCedula.name);
    } else {
      $('#preview').attr('src', './assets/img/cedula.png');
    }
  }

  // Envia los datos al servidor para crear un nuevo registro
  async guardar() {
    if (this.form.valid) {
      this.loading = true;


      if (this.form.get('foto_perfil').value !== this.foto) {

        this.uploadFileService.uploadCedula(this.imgCedula, this.form.get('cedula').value)
        .then(fileName => {
          this.form.get('foto_perfil').setValue(fileName);
          const data = this.form.value;
          data.fecha_nacimiento = data.fecha_nacimiento ? `${data.fecha_nacimiento.year}-${data.fecha_nacimiento.month}-${data.fecha_nacimiento.day}` : '';
          this.clienteService.editarSolicitud(data).subscribe(res => {
            this.loading = false;
            if (res) {
              this.alerts.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-pencil');
            }
          }, err => {
            this.loading = false;
            if (err) {
              this.alerts.validacionesModalJquery('Error de validación', err.error, 'red', 'modern');
            }
          });
        }).catch(() => this.loading = false);
      } else {

        const data = this.form.value;
        data.fecha_nacimiento = data.fecha_nacimiento ? `${data.fecha_nacimiento.year}-${data.fecha_nacimiento.month}-${data.fecha_nacimiento.day}` : '';
        this.clienteService.editarSolicitud(data).subscribe(res => {
          this.loading = false;
          if (res) {
            this.alerts.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-pencil');
          }
        }, err => {
          this.loading = false;
          if (err) {
            this.alerts.validacionesModalJquery('Error de validación', err.error, 'red', 'modern');
          }
        });
      }
    }
  }

  tiempoSplited(forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');

    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    return (tiempo.value as string).split(' ');
  }

  tiempoSelectChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');

    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        (typeof parseFloat(valueSplited[0]) == 'number' ? valueSplited[0] : 1) + ` ${value}`
      );

    } else {
      tiempo.setValue(`1 ${value}`);
    }

  }

  tiempoInputChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');
    
    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        value + ` ${valueSplited.length == 2 ? valueSplited[1] : valueSplited[0]}`
      );

    } else {
      tiempo.setValue(value + ` ${this.tiempo[2]}`);
    }
  }

  private setFormulario(): void {
    this.params.params
    .subscribe(params => {
      if (!isNaN(params.id)) {

        this.clienteService.detalleSolicitud(params.id)
        .subscribe((res: any) => {
          let fecha_nacimiento = res.solicitud.fecha_nacimiento.split('-');
          fecha_nacimiento = {
            year: parseFloat(fecha_nacimiento[0]),
            month: parseFloat(fecha_nacimiento[1]),
            day: parseFloat(fecha_nacimiento[2])
          };

          this.hasFoto = res.solicitud.foto ? true : false;
          this.foto = res.solicitud.foto || '';
          this.form.get('ID_SOLICITUD').setValue(res.solicitud.ID_PRESOLICITUD);
          this.form.get('foto_perfil').setValue(this.foto);
          this.form.get('sexo').setValue(String(res.solicitud.sexo));
          this.form.get('estado_civil').setValue(res.solicitud.estado_civil);
          this.form.get('fecha_nacimiento').setValue(fecha_nacimiento);
          this.form.get('identificacion').setValue(String(res.solicitud.identificacion).length <= 13 ? '1' : '2');
          this.form.get('cedula').setValue(res.solicitud.identificacion);
          this.form.get('nombre').setValue(res.solicitud.nombre);
          this.form.get('apellido').setValue(res.solicitud.apellido);
          this.form.get('apodo').setValue(res.solicitud.apodo);
          this.form.get('telefono').setValue(res.solicitud.telefono);
          this.form.get('monto').setValue(res.solicitud.monto);
          this.form.get('ID_RUTA').setValue(res.solicitud.ID_RUTA);
          this.form.get('direccion').setValue(res.solicitud.direccion);
          this.form.get('dependientes').setValue(res.solicitud.dependientes);
          this.form.get('finalidad').setValue(res.solicitud.finalidad);
          this.form.get('vivienda_propia').setValue(res.solicitud.vivienda_propia);
          this.form.get('vivienda_alquiler').setValue(res.solicitud.vivienda_alquiler);
          this.form.get('vivienda_tiempo').setValue(res.solicitud.vivienda_tiempo);
          this.form.get('datosNegocio').get('negocio_propio').setValue(res.solicitud.negocio_propio);
          this.form.get('datosNegocio').get('negocio_alquiler').setValue(res.solicitud.negocio_alquiler);
          this.form.get('datosNegocio').get('negocio_rnc').setValue(res.solicitud.negocio_rnc);
          this.form.get('datosNegocio').get('negocio_nombre').setValue(res.solicitud.negocio_nombre);
          this.form.get('datosNegocio').get('negocio_local').setValue(res.solicitud.negocio_local);
          this.form.get('datosNegocio').get('negocio_telefono').setValue(res.solicitud.negocio_telefono);
          this.form.get('datosNegocio').get('negocio_direccion').setValue(res.solicitud.negocio_direccion);
          this.form.get('datosNegocio').get('negocio_actividad').setValue(res.solicitud.negocio_actividad);
          this.form.get('datosNegocio').get('negocio_salario').setValue(res.solicitud.negocio_salario);
          this.form.get('datosNegocio').get('negocio_tiempo').setValue(res.solicitud.negocio_tiempo);
          this.form.get('datosNegocio').get('negocio_frecuencia_salario').setValue(res.solicitud.negocio_frecuencia_salario);

          if (this.foto) {
            this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${this.helper.compania}/${res.solicitud.identificacion}/cedulas/${this.foto}`;
          }
        });
      } else {

        this.route.navigate(['/404']);
      }
    }, () => {
      this.route.navigate(['/404']);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/editar-solicitud/editar-solicitud.component.ts